import React from 'react';
import PropTypes from 'prop-types';
import './styles/buttonSuccessIcon.scss';

export default function ButtonSuccessIcon({ size, variant }) {
  const isIconSmall = size === 'small' || size === 'medium';
  const isIconSecondary = !(variant === 'tonal' || variant === 'filled' || variant === 'elevated');

  return (
    <svg
      className={`button-success-icon${isIconSmall ? ' button-success-icon--small' : ''}`}
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 130.2 130.2'
    >
      <polyline
        className={`button-success-icon__stroke${isIconSecondary ? ' button-success-icon__stroke--secondary' : ''}`}
        fill='none'
        strokeWidth='9'
        strokeMiterlimit='10'
        points='100.2,40.2 51.5,88.8 29.8,67.5'
      />
    </svg>
  );
}

ButtonSuccessIcon.propTypes = {
  size: PropTypes.string,
  variant: PropTypes.string
};
